export class UkuEventType{
    static INITIALIZED:string = 'initialized';
	static REFRESH:string = 'refresh';
	static HANDLE_ELEMENT_COMPLETED:string = "handle_element_completed";
}


// WEBPACK FOOTER //
// ./src/core/UkuEventType.ts